import React, { createContext, useState, useContext } from 'react';
import { PersistContext } from "./PersistProvider";
import { LanguageConfig } from "@/config";

export const LanguageContext = createContext();
const DefaultLanguage = LanguageConfig.ind;

export const LanguageProvider = ({ children }) => {
  const { getPersist, setPersist } = useContext(PersistContext);
  const [language, setLanguage] = useState(DefaultLanguage);

  getPersist("language") && LanguageConfig[getPersist("language")] ? setLanguage(LanguageConfig[getPersist("language")]) : DefaultLanguage

  const changeLanguage = (_language) => {
    setLanguage(LanguageConfig[_language]);
    setPersist("language", _language)
  };

  const getLanguage = () => {
    if (getPersist("language")) {
      return getPersist("language")
    }
    return DefaultLanguage.name
  }

  // const langText = (key, params = {}) => {
  //   let translation = (language.langJson.text && language.langJson.text[key]) || language.langJson[key] || key;
  //   let paramIndex = 1;
  //   while (translation.includes(`[@]`)) {
  //     const paramKey = `param${paramIndex}`;
  //     if (params[paramKey] || params[paramKey] == 0) {
  //       translation = translation.replace(`[@]`, params[paramKey]);
  //     } else {
  //       break;
  //     }
  //     paramIndex++;
  //   }
  //   return translation;
  // };


  // 支持多语言
  const langText = (key, params = {}) => {
    let translation = (language.langJson.text && language.langJson.text[key]) || language.langJson[key] || key;

    // 处理参数替换，支持 React 元素
    if (params && Object.keys(params).length > 0) {
      // 将翻译文本拆分成数组，保留 HTML 标记
      const parts = translation.split(/(\[@\]|<\/?[a-z]+>)/g);

      // 构建最终的 React 元素数组
      const result = [];
      let paramIndex = 1;

      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];

        if (part === '[@]') {
          // 替换参数
          const paramKey = `param${paramIndex}`;
          if (params[paramKey] !== undefined) {
            result.push(params[paramKey]);
          }
          paramIndex++;
        } else if (part === '<red>') {
          // 开始红色标记
          result.push(<span key={`red-${i}`} style={{ color: 'red' }}>{parts[++i]}</span>);
        } else if (part === '<blue>') {
          // 开始蓝色标记
          result.push(<span key={`blue-${i}`} style={{ color: 'blue' }}>{parts[++i]}</span>);
        } else if (part === '</red>' || part === '</blue>') {
          // 忽略结束标记
          continue;
        } else {
          // 普通文本
          result.push(part);
        }
      }

      return result;
    }

    return translation;
  };
  const langImg = (key) => {
    return language.langJson.img[key] || key;
  }

  return (
    <LanguageContext.Provider value={{ language, getLanguage, changeLanguage, langText, langImg }}>
      {children}
    </LanguageContext.Provider>
  );
};
